(function () {
  if (window.__vhTry) return;
  window.__vhTry = true;
  var MP = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.3';
  var MODEL = 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';
  /* Solo se usan imágenes cuyo texto alternativo contenga una de estas palabras:
     deben ser fotos FRONTALES de la gafa sola, sobre fondo blanco o transparente. */
  var TRY_RX = /frontal|probador|try-?on/i;
  var CSS = '.vtr-btn{position:absolute;top:1.2rem;right:1.2rem;z-index:3;display:inline-flex;align-items:center;gap:.6rem;height:3.8rem;padding:0 1.4rem;border:0;border-radius:99px;background:rgba(255,255,255,.92);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px);color:#0a0a0a;font:inherit;font-size:1.3rem;font-weight:700;letter-spacing:0;cursor:pointer;box-shadow:0 .4rem 1.6rem rgba(0,0,0,.14)}'
    + '.vtr-btn svg{width:1.8rem;height:1.8rem}'
    + '.vtr{position:fixed;inset:0;z-index:2000;display:flex;flex-direction:column;background:#0a0a0a;color:#fff;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;letter-spacing:0}'
    + '.vtr__bar{display:flex;align-items:center;gap:1rem;padding:calc(1.2rem + env(safe-area-inset-top)) 1.6rem 1.2rem;font-size:1.7rem}'
    + '.vtr__beta{padding:.3rem .9rem;border-radius:99px;background:rgba(255,255,255,.16);font-size:1.1rem;letter-spacing:.1em;text-transform:uppercase}'
    + '.vtr__x{margin-left:auto;width:4.4rem;height:4.4rem;border:0;border-radius:50%;background:rgba(255,255,255,.14);color:#fff;font-size:2.6rem;line-height:1;cursor:pointer}'
    + '.vtr__stage{position:relative;flex:1;min-height:0;overflow:hidden;background:#111}'
    + '.vtr__stage canvas{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}'
    + '.vtr__msg{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);max-width:80%;padding:1.2rem 2rem;border-radius:2rem;background:rgba(0,0,0,.6);font-size:1.6rem;text-align:center}'
    + '.vtr__msg:empty{display:none}'
    + '.vtr__dock{padding:1.2rem 1.6rem calc(1.6rem + env(safe-area-inset-bottom));background:#0a0a0a}'
    + '.vtr__thumbs{display:flex;gap:.8rem;overflow-x:auto;margin-bottom:1.2rem;scrollbar-width:none}'
    + '.vtr__thumbs::-webkit-scrollbar{display:none}'
    + '.vtr__thumb{flex:0 0 6.4rem;height:6.4rem;padding:0;border:2px solid transparent;border-radius:1.4rem;background:#f4f4f4;overflow:hidden;cursor:pointer}'
    + '.vtr__thumb img{width:100%;height:100%;object-fit:contain}'
    + '.vtr__thumb.is-on{border-color:#fff}'
    + '.vtr__act{display:flex;gap:1rem}'
    + '.vtr__act button{flex:1;min-height:5rem;border:0;border-radius:99px;font:inherit;font-size:1.5rem;font-weight:700;cursor:pointer}'
    + '.vtr__snap{background:rgba(255,255,255,.16);color:#fff}.vtr__buy{background:#fff;color:#0a0a0a}'
    + '.vtr__priv{margin:1rem 0 0;font-size:1.2rem;opacity:.6;text-align:center}';

  var landmarker = null, loading = null, open = false, raf = 0, stream = null;
  var els = {}, glasses = null, bb = null, sm = null, images = [], lastT = -1;

  function loadLM() {
    if (landmarker) return Promise.resolve(landmarker);
    if (loading) return loading;
    loading = import(MP + '/vision_bundle.mjs').then(function (m) {
      return m.FilesetResolver.forVisionTasks(MP + '/wasm').then(function (fs) {
        function make(d) { return m.FaceLandmarker.createFromOptions(fs, { baseOptions: { modelAssetPath: MODEL, delegate: d }, runningMode: 'VIDEO', numFaces: 1 }); }
        return make('GPU').catch(function () { return make('CPU'); });
      });
    }).then(function (l) { landmarker = l; return l; });
    return loading;
  }

  function url(u, w) {
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function frameBox(img) {
    var full = { x: 0, y: 0, w: img.naturalWidth, h: img.naturalHeight };
    var s = Math.min(1, 500 / Math.max(img.naturalWidth, img.naturalHeight));
    var w = Math.max(1, Math.round(img.naturalWidth * s)), h = Math.max(1, Math.round(img.naturalHeight * s));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, w, h);
    var d;
    try { d = x.getImageData(0, 0, w, h).data; } catch (e) { return full; }
    var minX = w, minY = h, maxX = 0, maxY = 0;
    for (var yy = 0; yy < h; yy++) {
      for (var xx = 0; xx < w; xx++) {
        var i = (yy * w + xx) * 4;
        if (d[i + 3] > 20 && (d[i] < 205 || d[i + 1] < 205 || d[i + 2] < 205)) {
          if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
          if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
        }
      }
    }
    if (maxX <= minX || maxY <= minY) return full;
    return { x: minX / s, y: minY / s, w: (maxX - minX) / s, h: (maxY - minY) / s };
  }

  function setGlasses(i) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { glasses = img; bb = frameBox(img); sm = null; };
    img.onerror = function () { glasses = null; msg('No hemos podido cargar esa imagen.'); };
    img.src = url(images[i], 900);
    var ts = els.thumbs.querySelectorAll('.vtr__thumb');
    for (var k = 0; k < ts.length; k++) ts[k].classList.toggle('is-on', k === i);
  }

  function msg(t) { if (els.msg) els.msg.textContent = t || ''; }

  function loop() {
    if (!open) return;
    raf = requestAnimationFrame(loop);
    var v = els.video, c = els.canvas, ctx = els.ctx;
    if (v.readyState < 2) return;
    var vw = v.videoWidth, vh = v.videoHeight;
    if (c.width !== vw || c.height !== vh) { c.width = vw; c.height = vh; }
    ctx.globalCompositeOperation = 'source-over';
    ctx.save(); ctx.scale(-1, 1); ctx.drawImage(v, -vw, 0, vw, vh); ctx.restore();
    if (!landmarker || !glasses || !bb) return;
    var now = performance.now();
    if (now === lastT) return;
    lastT = now;
    var res = landmarker.detectForVideo(v, now);
    var lm = res && res.faceLandmarks && res.faceLandmarks[0];
    if (!lm) { msg('Mira de frente a la cámara'); return; }
    msg('');
    function P(n) { return { x: (1 - lm[n].x) * vw, y: lm[n].y * vh }; }
    var a = P(33), b = P(263), l = P(234), r = P(454);
    var faceW = Math.hypot(l.x - r.x, l.y - r.y);
    var cur = { cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2 + faceW * 0.02, W: faceW * 1.0, ang: Math.atan2(a.y - b.y, a.x - b.x) };
    if (!sm) sm = cur; else { var k = 0.55; sm = { cx: sm.cx + (cur.cx - sm.cx) * k, cy: sm.cy + (cur.cy - sm.cy) * k, W: sm.W + (cur.W - sm.W) * k, ang: sm.ang + (cur.ang - sm.ang) * k }; }
    var H = sm.W * bb.h / bb.w;
    ctx.save();
    ctx.translate(sm.cx, sm.cy);
    ctx.rotate(sm.ang);
    ctx.globalCompositeOperation = 'multiply';
    ctx.drawImage(glasses, bb.x, bb.y, bb.w, bb.h, -sm.W / 2, -H / 2, sm.W, H);
    ctx.restore();
  }

  function close() {
    open = false;
    cancelAnimationFrame(raf);
    if (stream) stream.getTracks().forEach(function (t) { t.stop(); });
    stream = null;
    if (els.root && els.root.parentNode) els.root.parentNode.removeChild(els.root);
    els = {};
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  function openModal() {
    var root = document.createElement('div');
    root.className = 'vtr'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Probador virtual');
    root.innerHTML = '<div class="vtr__bar"><strong>Pruébatelas</strong><span class="vtr__beta">Beta</span><button type="button" class="vtr__x" aria-label="Cerrar">&times;</button></div>'
      + '<div class="vtr__stage"><canvas></canvas><div class="vtr__msg"></div></div>'
      + '<div class="vtr__dock"><div class="vtr__thumbs"></div><div class="vtr__act"><button type="button" class="vtr__snap">Hacer foto</button><button type="button" class="vtr__buy">Me las quedo</button></div>'
      + '<p class="vtr__priv">La cámara se procesa en tu dispositivo. No se guarda ni se envía ninguna imagen. Prueba orientativa.</p></div>';
    document.body.appendChild(root);
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var video = document.createElement('video');
    video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', ''); video.setAttribute('autoplay', ''); video.muted = true;
    video.style.cssText = 'position:absolute;opacity:0;width:1px;height:1px;pointer-events:none';
    root.appendChild(video);
    els = { root: root, video: video, canvas: root.querySelector('canvas'), msg: root.querySelector('.vtr__msg'), thumbs: root.querySelector('.vtr__thumbs') };
    els.ctx = els.canvas.getContext('2d');
    images.slice(0, 8).forEach(function (u, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'vtr__thumb'; b.setAttribute('aria-label', 'Probar imagen ' + (i + 1));
      var im = document.createElement('img'); im.alt = ''; im.src = url(u, 160); b.appendChild(im);
      b.addEventListener('click', function () { setGlasses(i); });
      els.thumbs.appendChild(b);
    });
    if (images.length < 2) els.thumbs.style.display = 'none';
    root.querySelector('.vtr__x').addEventListener('click', close);
    root.querySelector('.vtr__snap').addEventListener('click', function () {
      els.canvas.toBlob(function (blob) {
        if (!blob) return;
        var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'venice-prueba.jpg';
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
      }, 'image/jpeg', 0.92);
    });
    root.querySelector('.vtr__buy').addEventListener('click', function () {
      close();
      var atc = document.querySelector('[data-atc]');
      if (atc) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
    document.addEventListener('keydown', onKey);
    open = true;
    msg('Cargando cámara…');
    setGlasses(0);
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 720 } }, audio: false })
      .then(function (s) { stream = s; video.srcObject = s; return video.play(); })
      .then(function () { msg('Cargando probador…'); loop(); return loadLM(); })
      .then(function () { msg(''); })
      .catch(function (err) {
        msg(err && err.name === 'NotAllowedError' ? 'No hemos podido acceder a la cámara. Revisa los permisos del navegador.' : 'El probador no está disponible en este dispositivo.');
      });
  }

  function boot() {
    var root = document.querySelector('[data-vp-root]');
    if (!root || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return;
    if (window.Shopify && Shopify.designMode) return;
    var media = root.querySelector('.vp__stage') || root.querySelector('.vp__media');
    var js = root.querySelector('[data-product-json]');
    if (!media || !js) return;
    var p = {};
    try { p = JSON.parse(js.textContent); } catch (e) { return; }
    images = (p.media || []).filter(function (m) { return m.media_type === 'image' && TRY_RX.test(m.alt || ''); }).map(function (m) { return m.src || (m.preview_image && m.preview_image.src); }).filter(Boolean);
    if (!images.length) return;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'vtr-btn';
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 8V5a1 1 0 011-1h3M16 4h3a1 1 0 011 1v3M20 16v3a1 1 0 01-1 1h-3M8 20H5a1 1 0 01-1-1v-3"/><circle cx="9" cy="12" r="2"/><circle cx="15" cy="12" r="2"/><path d="M11 12h2"/></svg>Pruébatelas';
    b.addEventListener('click', openModal);
    media.appendChild(b);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
